import { GameConstants } from "../GameConstants";

    export class AdvicesManager  {

        private static _instance: AdvicesManager = null;

        private game: Phaser.Game;
        private advicesArray: any;
        private messageIndex: number;

        public static getInstance(): AdvicesManager {

            if (AdvicesManager._instance === null) {
                AdvicesManager._instance = new AdvicesManager();
            }

            return AdvicesManager._instance;
        }

        constructor() {

            if ( AdvicesManager._instance ) {
                throw new Error("Error: Instantiation failed: Use AdvicesManager.getInstance() instead of new.");
            }

            AdvicesManager._instance = this;
        }

        public init(game: Phaser.Game): void {

            this.game = game;

            var gameText: any = this.game.cache.getJSON("game_text");

            if ( GameConstants.LANGUAGE === GameConstants.ENGLISH ) {
                this.advicesArray = gameText.en.ADVICES;
            } else {
                this.advicesArray = gameText.ru.ADVICES;
            }

            this.messageIndex = Math.floor(Math.random() * (this.advicesArray.length - 1));
        }

        public getMessage (): string {

            // poner algun algoritmo llegado el caso
            let message: string = this.advicesArray[ this.messageIndex ];

            this.messageIndex =  this.messageIndex < this.advicesArray.length - 1 ? this.messageIndex + 1 : 0;

            return message;
        }
    }
